import EditPolicy from './EditPolicy';
export default EditPolicy;
